// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});




	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});




	// STICKY HEADER
	let lastScrollY = 0; // Keep track of the last scroll position

	function toggleStickyHeader() {
	const header = document.getElementById('sticky-header');
	const currentScrollY = window.scrollY; // Get the current scroll position
	
	// If the user has scrolled more than 200 pixels down the page
	if (currentScrollY >= 200) {
		// Check if the user is scrolling up
		if (currentScrollY < lastScrollY) {
		// Add the 'visible' class to make the sticky header fade in
		header.classList.add('visible');
		header.classList.remove('hidden');
		} else {
		// Remove the 'visible' class to make the sticky header fade out
		header.classList.add('hidden');
		header.classList.remove('visible');
		}
	} else {
		// Remove the 'visible' class to make the sticky header fade out
		header.classList.add('hidden');
		header.classList.remove('visible');
	}
	
	// Update lastScrollY for the next scroll event
	lastScrollY = currentScrollY;
	}

	// Attach the toggleStickyHeader function to the window's scroll event
	window.addEventListener('scroll', toggleStickyHeader);


	

	// OWL CAROUSEL
	jQuery(document).ready(function(){
		jQuery('.owl-carousel').owlCarousel({
			loop: true,
			margin: 24,
			nav: true,
			autoplay: false,
			autoHeight: false,
			dots: false,
			navText: [
				'<svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38" fill="none"><path d="M19 2L2 19L19 36" stroke="#211E1D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
				'<svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38" fill="none"><path d="M2 36L19 19L2 2" stroke="#211E1D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
			],
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 3
				}
			}
		});
	});



	/*
	// QUANTITY INPUT
	// Function to handle the increment action
	// This function finds the input element and increases its value by 1.
	function increment() {
	const inputElement = document.getElementById('quantity');
	inputElement.value = parseInt(inputElement.value, 10) + 1;
	}

	// Function to handle the decrement action
	// This function finds the input element and decreases its value by 1.
	function decrement() {
	const inputElement = document.getElementById('quantity');
	const currentValue = parseInt(inputElement.value, 10);
	if (currentValue > 0) {
		inputElement.value = currentValue - 1;
	}
	}

	// Add event listeners for the increment and decrement buttons
	document.querySelector('.increment').addEventListener('click', increment);
	document.querySelector('.decrement').addEventListener('click', decrement);
	*/

})();

jQuery(document).ready(function() {

    jQuery('.selection').html('');

    jQuery('.variations li').on('click', function(e) {

        jQuery(this).closest('ul').find('li').attr('aria-checked', 'false');
        
        jQuery(this).closest('ul').data('selectedOption', jQuery(this).data('title'));
        
        jQuery('.variations li[aria-checked=true]').each(function() {

            jQuery(this).closest('ul').data('selectedOption', jQuery(this).data('title'));

        });

        var selectedOptions = [];

        jQuery('.variations ul').each(function() {

            if (jQuery(this).data('selectedOption')) {
                
                selectedOptions.push(jQuery(this).data('selectedOption'));

            }       

        });

        var selectedOptionsString = selectedOptions.join(', ');

        jQuery('.selection').html(selectedOptionsString);

    });

	jQuery('.reset_variations').on('click', function(e) {

		jQuery('.selection').html('');
		jQuery('.qty').val(1);

	});

});

jQuery(document).ready(function() {

	jQuery('.dropdown-menu').closest('li').find('a.nav-link').on('mouseenter', function() {jQuery(this).closest('li').find('.dropdown-menu').show()});
	jQuery('.dropdown-menu').closest('li').find('a.nav-link').on('mouseleave', function() {jQuery(this).closest('li').find('.dropdown-menu').hide()});
	jQuery('.dropdown-menu').on('mouseenter', function() {jQuery(this).show()});
	jQuery('.dropdown-menu').on('mouseleave', function() {jQuery(this).hide()});

});